export const DONT_FIT = 'DONT_FIT';
export const EXCLUDED = 'EXCLUDED';
export const FIT = 'FIT';

export enum CheckFitResult {
  DONT_FIT = 'DONT_FIT',
  EXCLUDED = 'EXCLUDED',
  FIT = 'FIT'
}
